import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { EyeIcon, XIcon } from 'lucide-react';
import { ProductionView } from '../ProductionView';
import type { Production } from '../../types/production';
interface PreviewDialogProps {
  production: Production | null;
  onClose: () => void;
}
export function PreviewDialog({
  production,
  onClose
}: PreviewDialogProps) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const open = !!production;
  useEffect(() => {
    if (!open) return;
    const previous = document.activeElement as HTMLElement | null;
    closeRef.current?.focus();
    document.body.style.overflow = 'hidden';
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
      previous?.focus();
    };
  }, [open, onClose]);
  return <AnimatePresence data-id="element-41" data-mp="22689a2risxzo">
      {production && <motion.div role="dialog" aria-modal="true" aria-label="Vista previa de la ficha" className="fixed inset-0 z-50 flex flex-col bg-night" initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 12
    }} transition={{
      duration: 0.24,
      ease: [0.23, 1, 0.32, 1]
    }} data-id="element-42" data-mp="2256oh6kpcx4r">
          <div className="flex h-14 shrink-0 items-center justify-between border-b border-graphite bg-coal px-5 md:px-10" data-id="element-43" data-mp="2kyk7cdb55d40">
            <p className="flex items-center gap-2 text-sm font-medium text-white" data-id="element-44" data-mp="2pyf06meh8crp">
              <EyeIcon className="h-4 w-4 text-mist" data-id="element-45" data-mp="2b6wmwwd04wc1" />
              Vista previa · así se verá la ficha publicada
            </p>
            <button ref={closeRef} type="button" onClick={onClose} aria-label="Cerrar vista previa" className="inline-flex h-9 w-9 items-center justify-center rounded-md text-white transition-colors duration-150 ease-out hover:bg-white/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white" data-id="element-46" data-mp="2g46ae6gtyxx8">
              <XIcon className="h-5 w-5" data-id="element-47" data-mp="3dhwhfkq9qeys" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto" data-id="element-48" data-mp="39gax5ebemyek">
            <ProductionView production={production} showRelated={false} data-id="element-49" data-mp="34jkhut7fc6u7" />
          </div>
        </motion.div>}
    </AnimatePresence>;
}